import CommunicationJoinButton from "./communication-join-button";

export default CommunicationJoinButton;